import React, { useContext } from "react";
import { useSelector } from "react-redux";
import MetaProperty from "components/MetaProperties/MetaProperty";
import { ContentContext } from "context/Content";

function ArticleMeta(props) {
    const block = props.block;
    const { state } = useContext(ContentContext);
    const contentFlow = useSelector((state) => state.contentFlow);

    return (
        <div className="mb-6 space-y-6">
            {contentFlow.metaProperties[block]?.map((metaProp, index) => (
                <MetaProperty
                    key={index}
                    type={metaProp.type}
                    label={metaProp.label}
                    field={metaProp.field}
                    initialValue={
                        state.content.metaProperties.find(
                            (mp) => mp.field === metaProp.field
                        )?.value
                    }
                    nameMask="meta[{field}]"
                />
            ))}
        </div>
    );
}

export default ArticleMeta;
